import { Button, Container, Box, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom"; 
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { auth } from "../../firestore-DB-config/firebase-config"; 
import { signOut } from "firebase/auth";
import LogoutIcon from "@mui/icons-material/Logout"; 

function AddButtons() {
  const navigate = useNavigate(); 

  const handleLogout = () => {
    signOut(auth).then(() => {
      navigate("/login"); // Redirect to login page after logging out
    });
  };

  return (
    <>
      <Header />
      <Container sx={{ my: "40px" }}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="flex-start" // Align items at the start
          alignItems="center"
          minHeight="80vh"
          gap={3}
          sx={{
            backgroundColor: "#f8f9fa",
            borderRadius: "10px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            p: 4,
            overflow: "hidden",
          }}
        >
          {/** Logout Button - Wrapped in a Box for alignment */}
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              onClick={handleLogout}
              sx={{
                fontSize: "16px", 
                fontWeight: "600",
                padding: "10px 20px", 
                borderRadius: "35px",
                textTransform: "none",
                bgcolor: "#dc3545",
                color: "#fff",
                border: "1px solid transparent", 
                boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
                "&:hover": {
                  bgcolor: "#c82333", // Darker red on hover
                  transform: "scale(1.05)", 
                  border: "1px solid #c82333", // Border color on hover
                },
                transition:
                  "background-color 0.3s ease, transform 0.3s ease, border 0.3s ease", 
              }}
              variant="contained"
              startIcon={<LogoutIcon />} 
            >
              Logout
            </Button>
          </Box>

          {/** Manage Your Content Text */}
          <Typography
            sx={{ mb: 2, fontWeight: 600, textAlign: "center", fontSize: "30px" }} // Reduced margin bottom for better spacing
          >
            Manage Your Content
          </Typography>

          {/** Add Buttons Section */}
          <Typography
            gutterBottom
            sx={{ fontSize: { xs: "1rem", md: "1.5rem" }, fontWeight: "500" }}
          >
            Add Content
          </Typography>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent="center"
            gap={2}
            flexWrap="wrap"
            width="100%" 
          >
            {/** Button Component */}
            {[
              { path: "/add-property", label: "Add New Property" },
              { path: "/add-review", label: "Add a Review" },
              { path: "/add-blogs", label: "Add a Blog" },
              { path: "/add-services", label: "Add a Service" },
              { path: "/add-aboutus", label: "Add About Us" },
              { path: "/add-terms", label: "Add Terms & Conditions" },
              { path: "/add-privacy", label: "Add Privacy Policy" },
              { path: "/add-teamMembers", label: "Add Team Members" },
            ].map(({ path, label }) => (
              <Button
                key={path}
                variant="contained"
                component={Link}
                to={path}
                sx={{
                  width: { xs: "100%", sm: "250px" },
                  bgcolor: "#007bff",
                  "&:hover": {
                    bgcolor: "#0056b3",
                  },
                  transition: "background-color 0.3s ease",
                  borderRadius: "20px",
                }}
              >
                {label}
              </Button>
            ))}
          </Box>

          {/** Delete Buttons Section */}
          <Typography
            gutterBottom
            sx={{ fontSize: { xs: "1rem", md: "1.5rem" }, fontWeight: "500" }}
          >
            Delete Content
          </Typography>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent="center"
            gap={2}
            flexWrap="wrap"
            width="100%" 
          >
            {/** Button Component */}
            {[
              { path: "/delete-properties", label: "Delete Property" },
              { path: "/delete-blogs", label: "Delete Blog" },
            ].map(({ path, label }) => (
              <Button
                key={path}
                variant="contained"
                component={Link}
                to={path}
                sx={{
                  width: { xs: "100%", sm: "250px" },
                  bgcolor: "#dc3545",
                  "&:hover": {
                    bgcolor: "#c82333",
                  },
                  transition: "background-color 0.3s ease",
                  borderRadius: "20px",
                }}
              >
                {label}
              </Button>
            ))}
          </Box>
        </Box>
      </Container>
      <Footer />
    </>
  );
}

export default AddButtons;
